export default [
  // '/task/taskDetail',
  // '/task/taskList',
  // '/taskTemplate/trainTemplateList',
  '/trainingStandard/delete',
  '/trainingStandard/save',
  '/trainingStandard/modify',
  // '/third/training/record/list',
]
